"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _hasMultipleConditions = _interopRequireDefault(require("./hasMultipleConditions"));

var _getChallengeConditions = _interopRequireDefault(require("./getChallengeConditions"));

var getSingleCondition = function getSingleCondition(conditions) {
  if (!conditions) {
    return 'points';
  }

  var _conditions$combinati = conditions.combinations,
      combinations = _conditions$combinati === void 0 ? [] : _conditions$combinati,
      _conditions$unit = conditions.unit,
      unit = _conditions$unit === void 0 ? '' : _conditions$unit;

  if ((0, _hasMultipleConditions["default"])({
    conditions: conditions
  })) {
    return 'points';
  }

  if (combinations && combinations.length > 0) {
    return 'points';
  }

  var getChallengeSingleCondition = function getChallengeSingleCondition() {
    var result = (0, _getChallengeConditions["default"])(conditions);

    if (result[0]) {
      return result[0];
    }

    return 'points';
  };

  return unit ? unit : getChallengeSingleCondition();
};

var _default = getSingleCondition;
exports["default"] = _default;
//# sourceMappingURL=getSingleCondition.js.map